module.exports = __webpack_public_path__ + "img/demo-booking.ad0b7f61.png";